import { Component, h, Prop, Host, Element } from "@stencil/core";
import { MyMachinesResponse } from "./my-machines-response";

@Component({
    tag: "ux-w-my-machines",
    styleUrl: "my-machines.scss",
    shadow: false
})
export class MyMachines {
    /** This holds the response from the API with all Information required to show the widget */
    @Prop() data: MyMachinesResponse = null;
    /** data is loading */
    @Prop() dataLoading: boolean = false;

    @Element() host: HTMLUxWMyMachinesElement;

    render() {
        const baseClass = "ux-w-my-machines";
        if (this.dataLoading) {
            return (
                <Host class={baseClass}>
                    <ux-w-wrapper isLoading />
                </Host>
            );
        }
        if (this.data === null) {
            return null;
        }
        const {
            link,
            linkTitle,
            title,
            items,
            messages,
            noData,
            noDataText,
            noMachinesText,
            noMachinesButton,
            additionalTile,
            isCreateCaseAllowed,
            disabledCreateCaseHeaderText,
            disabledCreateCaseBodyText,
            authImages
        } = this.data;
        const hasItems = items?.length > 0;

        return (
            <Host class={baseClass}>
                <ux-w-wrapper url={link} linkTitle={linkTitle} headline={title}>
                    <div slot="content">
                        {!hasItems && !noData && (
                            <ux-w-empty
                                link={link}
                                linkText={noMachinesButton}
                                icon="machine-fav"
                            >
                                <div innerHTML={noMachinesText} />
                            </ux-w-empty>
                        )}
                        {!hasItems && noData && (
                            <ux-w-empty icon="crane">
                                <div innerHTML={noDataText} />
                            </ux-w-empty>
                        )}
                        {items?.map(
                            ({
                                name,
                                number,
                                image,
                                detailLink,
                                shopLinks,
                                serviceCallLink,
                                serviceCallModalLink
                            }) => (
                                <ux-w-my-machines-item
                                    class={`${baseClass}__item`}
                                    machineName={name}
                                    machineId={number}
                                    machineImageUrl={image}
                                    detailLink={detailLink}
                                    serviceCallLink={serviceCallLink}
                                    serviceCallModalLink={serviceCallModalLink}
                                    serviceCallLinkText={
                                        messages.serviceCallLinkText
                                    }
                                    serviceCaseCreateDisabled={
                                        !isCreateCaseAllowed
                                    }
                                    serviceCaseCreateDisabledHeaderText={
                                        disabledCreateCaseHeaderText
                                    }
                                    serviceCaseCreateDisabledBodyText={
                                        disabledCreateCaseBodyText
                                    }
                                    shopLinks={shopLinks}
                                    chooseShopTitle={messages.chooseShop}
                                    detailLinkText={messages.detailLinkText}
                                    authImage={authImages}
                                />
                            )
                        )}
                        {hasItems && (
                            <ux-w-link-item
                                class={`${baseClass}__item`}
                                headline={additionalTile.title}
                                icon="cart-genuine-parts"
                                link={additionalTile.link}
                                linkLabel={additionalTile.linkText}
                            />
                        )}
                    </div>
                </ux-w-wrapper>
            </Host>
        );
    }
}
